import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class ECLService {
	private readonly uri: string = `${environment.DO_URL}/v2`;

	constructor(private readonly http: HttpClient) {}

	// Application CRUD operations
	getLoanStaging(input_date: string): Observable<any> {
		return this.http.get(`${this.uri}/loan-staging/${input_date}`);
	}

	getAccruedInterest(input_date: string): Observable<any> {
		return this.http.get(`${this.uri}/accrued-interest/${input_date}`);
	}

	getLoanGroupTransferAccrued(input_date: string): Observable<any> {
		return this.http.get(`${this.uri}/loan-group-transfer-accrued/${input_date}`);
	}

	getLoanMovement(input_date_1: string, input_date_2: string): Observable<any> {
		return this.http.get(`${this.uri}/loan-movement/${input_date_1}/${input_date_2}`);
	}

	getECLLoanStaging(input_date: string): Observable<any> {
		return this.http.get(`${this.uri}/ecl-loan-staging/${input_date}`);
	}

	getECLAccruedInterest(input_date: string): Observable<any> {
		return this.http.get(`${this.uri}/ecl-accrued-interest/${input_date}`);
	}

	getLoans(input_date: string, stage: number | string, risk: string): Observable<any> {
		return this.http.get(`${this.uri}/loans/${input_date}/${stage}/${risk}`);
	}
}
